import { redirect } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";
import { requireAuth } from "../auth/RequireAuth";
import { userStore } from "../../store/user";
import { EventSummaryHubPage } from "./EventSummaryHubPage";

// Admin-only: page contains cross-vendor payout config + cashless balance totals.
const eventSummaryAuthGate = async () => {
  const user = userStore.getState().user;
  if (!user) return redirect("/login");
  if (user.role_id !== 1) return redirect("/");
  return null;
};

export const eventSummaryRouter = {
  path: "/event-summary",
  id: "event-summary",
  element: <EventSummaryHubPage />,
  loader: requireAuth(undefined, eventSummaryAuthGate),
  handle: {
    crumb: () => <Breadcrumb name="Event Summary" href="/event-summary" />,
  },
};
